export const recoverPassForm = [
    {
        cols: [
            {
                formGroup: 'dniForm',
                class: 'col-lg-8 col-10',
                title: 'Recuperar contraseña',
                titleClass: 'form-title text-center'
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-lg-6 col-10',
                subtitle: 'Para recuperar tu contraseña tendrás que introducir en el siguiente paso el código que enviaremos al email que figura en tu cuenta. Por favor introduce tu DNI.',
                subtitleClass: 'form-subtitle text-center'
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-lg-6 col-10',
                item: 'input',
                type: 'text',
                placeholder: 'DNI',
                inputClass: 'text-input',
                formControlName: 'dni',
                required: true
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-lg-6 col-10',
                item: 'recaptcha',
                formControlName: 'recaptcha',
                inputClass: 'recaptcha',
                required: true
            }
        ]
    },
    {
        cols: [
            {
                class: 'col-4 col-sm-3 col-md-2',
                item: 'button',
                type: 'regular',
                submit: 'false',
                placeholder: 'Volver',
                inputClass: 'form-button mt-3 btn btn-primary',
                buttonAction: 'navigateToHome'
            },
            {
                class: 'col-4',
                item: 'button',
                type: 'regular',
                submit: 'true',
                placeholder: 'Enviar',
                inputClass: 'form-button mt-3 btn btn-primary',
                buttonAction: 'onSubmit'
            }
        ]
    }
]

